"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BlobIcons = void 0;
var _react = _interopRequireDefault(require("react"));
var _Improve = _interopRequireDefault(require("./BlobIcons/Improve"));
var _Celebrate = _interopRequireDefault(require("./BlobIcons/Celebrate"));
var _CheckMark = _interopRequireDefault(require("./BlobIcons/CheckMark"));
var _Down = _interopRequireDefault(require("./BlobIcons/Down"));
var _Alert = _interopRequireDefault(require("./BlobIcons/Alert"));
var _Up = _interopRequireDefault(require("./BlobIcons/Up"));
var _Warning = _interopRequireDefault(require("./BlobIcons/Warning"));
var _WarningHigh = _interopRequireDefault(require("./BlobIcons/WarningHigh"));
var _Info = _interopRequireDefault(require("./BlobIcons/Info"));
var _LightBulb = _interopRequireDefault(require("./BlobIcons/LightBulb"));
var _NoChange = _interopRequireDefault(require("./BlobIcons/NoChange"));
var _ThumbsUp = _interopRequireDefault(require("./BlobIcons/ThumbsUp"));
var _ThumbsUpGreen = _interopRequireDefault(require("./BlobIcons/ThumbsUpGreen"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BlobIcons = exports.BlobIcons = {
  improve: _Improve["default"],
  up: _Up["default"],
  alert: _Alert["default"],
  celebrate: _Celebrate["default"],
  checkMark: _CheckMark["default"],
  down: _Down["default"],
  warning: _Warning["default"],
  warningHigh: _WarningHigh["default"],
  info: _Info["default"],
  lightBulb: _LightBulb["default"],
  noChange: _NoChange["default"],
  thumbsUp: _ThumbsUp["default"],
  thumbsUpGreen: _ThumbsUpGreen["default"]
};
var BlobIcon = function BlobIcon(_ref) {
  var blobName = _ref.blobName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 40 : _ref$size,
    title = _ref.title;
  if (blobName === undefined) {
    return null;
  }
  var BlobIconComponent = BlobIcons[blobName];
  return /*#__PURE__*/_react["default"].createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    "aria-labelledby": "blob-icon-".concat(blobName, "-title")
  }, /*#__PURE__*/_react["default"].createElement("title", {
    id: "blob-icon-".concat(blobName, "-title")
  }, title !== null && title !== void 0 ? title : "Blob Icon ".concat(blobName)), /*#__PURE__*/_react["default"].createElement(BlobIconComponent, null));
};
var _default = exports["default"] = BlobIcon;